"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectField = void 0;
const react_1 = __importDefault(require("react"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const formik_1 = require("formik");
//eslint-disable-next-line
function SingleSelectField({ addNone = false, ...props }) {
    var _a;
    const [field, meta] = formik_1.useField(props.field);
    return (react_1.default.createElement(TextField_1.default, Object.assign({}, props, field, { SelectProps: {
            ...props.SelectProps,
            native: true,
        }, error: Boolean(meta.touched && meta.error), select: true, helperText: meta.touched && meta.error ? meta.error : '' }),
        addNone && (react_1.default.createElement("option", { key: 'None_key_0_' + field.name, value: typeof field.value === 'string' ? '' : -1 }, "None")), (_a = props.data) === null || _a === void 0 ? void 0 :
        _a.map(({ id, description }, idx) => {
            return (react_1.default.createElement("option", { key: `${description}_${idx}`, value: id }, description));
        })));
}
exports.SingleSelectField = SingleSelectField;
